/**
 * Sets the CSS variable `--vw` on `document.body` to the value of 1vw in pixels,
 * calculated from the content viewport width (`documentElement.clientWidth`),
 * i.e., viewport width excluding scrollbars.
 * Example: for a viewport width of 1905px, sets `--vw: 19.05px`.
 * Updates the value on window resize.
 */
(function () {
	'use strict';

	function setVwPxOnBody() {
		if (!document.body) {
			return;
		}
		const oneVwPx = document.documentElement.clientWidth * 0.01;
		document.body.style.setProperty(
			'--vw',
			`${oneVwPx.toFixed(2)}px`
		);
	}

	function init() {
		setVwPxOnBody();
		window.addEventListener('resize', setVwPxOnBody, { passive: true });
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
